import {
	ChangeDetectionStrategy,
	Component,
	inject,
	signal,
} from '@angular/core';
import {
	DirectionOfAmountSettings,
	DOAOperators,
} from '@models/businessSettings/settings';
import { Store } from '@ngxs/store';
import { BusinessDispatch, BusinessState } from '@state/business';
import { ICON } from '@core/util/icon';
import { RadioGroupItem } from 'src/app/shared/atomic/atoms/radio-group/radio-group.component';
import {
	DirectionOfFeeType,
	DirectionOfFeeString,
} from '@models/businessSettings/directionOfFees';
import { openClose } from '@core/animations/animations';
import { TestHooks } from './direction-of-amount.hooks';

@Component({
	selector: 'app-direction-of-amount',
	templateUrl: './direction-of-amount.component.html',
	animations: [openClose()],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class DirectionOfAmountComponent {
	testHooks = TestHooks;
	public dollar = ICON.DOLLAR;
	public info = ICON.INFO_SQUARE;
	public directionAmountOptions: RadioGroupItem<DOAOperators>[] = [
		{
			label: 'Less than',
			value: DOAOperators.LESS_THAN,
		},
		{
			label: 'Greater than',
			value: DOAOperators.GREATER_THAN,
		},
	];

	public doaLocations = DirectionOfFeeType;
	public directionOfFeeString = DirectionOfFeeString;
	public focusInput_ = signal(false);
	public settings$ = inject(Store).select(BusinessState.getDirectionOfAmount);

	constructor(private businessDispatch: BusinessDispatch) {}

	setLocation(location: DirectionOfFeeType): void {
		if (location === DirectionOfFeeType.TRUST_LEDGER) {
			this.setSubjectToHST(false);
		} else if (location === DirectionOfFeeType.NONE) {
			this.setShowCounselCredit(false);
		}
	}

	setOperator(
		operator: DOAOperators,
		directionOfAmount: DirectionOfAmountSettings,
	): void {
		if (directionOfAmount.amount <= 0 && operator === DOAOperators.LESS_THAN) {
			this.focusInput_.set(true);
		} else {
			this.focusInput_.set(false);
		}

		this.businessDispatch.OverwriteBusinessFields(
			'defaultSettings.titleInsurance.directionOfAmount.operator',
			operator,
		);
	}

	setAmount(
		amount: number,
		directionOfAmount: DirectionOfAmountSettings,
	): void {
		if (directionOfAmount.operator === DOAOperators.LESS_THAN && amount <= 0) {
			return;
		}

		this.businessDispatch.OverwriteBusinessFields(
			'defaultSettings.titleInsurance.directionOfAmount.amount',
			amount,
		);
	}

	setSubjectToHST(subjectToHST: boolean): void {
		this.businessDispatch.OverwriteBusinessFields(
			'defaultSettings.titleInsurance.directionOfAmount.subjectToHSTInSOA',
			subjectToHST,
		);
	}

	setShowCounselCredit(showCounselCredit: boolean): void {
		this.businessDispatch.OverwriteBusinessFields(
			'defaultSettings.titleInsurance.showCounselCredit',
			showCounselCredit,
		);
	}
}
